import React, {useEffect, useState} from "react";
import {Box} from "@mui/material";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";

interface BounceProps {
  children: JSX.Element|JSX.Element[];
  sx?: SxProps<Theme>;
}

export default function Bounce(props: BounceProps): JSX.Element {
  const {children, sx} = props;

  const [animate, setAnimate] = useState<boolean>(false);
  
  useEffect(() => {
    if (!animate) {
      setTimeout(() => (setAnimate(true)), 3000);
    } else {
      setTimeout(() => (setAnimate(false)), 2000);
    }
  }, [animate])

  return (
    <Box sx={{
      animation: `${animate ? "bounce 1s linear" : "none"}`, 
      "@keyframes bounce": {
        "0%": {
          transform: "translateX(0)"
        },
        "20%": {
          transform: "translateX(0)"
        },
        "40%": {
          transform: "translateX(-5px)"
        },
        "50%": {
          transform: "translateX(5px)"
        },
        "60%": {
          transform: "translateX(-5px)"
        },
        "80%": {
          transform: "translateX(0)"
        },
        "100%": {
          transform:  "translateX(0)"
        }
      },
      ...sx
    }}>
      {children}
    </Box> 
  )
}
